<template>
    <div id="gamePrice">
        <div>
            <headerPage :title="title" :iconSrc="iconSrc" :headerSty="headerSty"></headerPage>
            <headerBg class="headerBg" :headerBg="headerBg"></headerBg>
            <div class="txtBox" :class="$route.query.type == 'xbox' ? 'xboxBox' : ''">
                <div class="txt" v-if="$route.query.type == 'steam' || $route.query.type == 'psn'">
                    在2024年你一共购买了<span class="txt1" :style="colorSty">{{ data.gameNumber }}</span
                    >款游戏
                </div>
                <div class="txt" v-if="$route.query.type == 'xbox'">
                    在2024年你一共游玩了<span class="txt1" :style="colorSty">{{ data.gameNumber }}</span
                    >款游戏
                </div>
                <div class="txt" v-if="$route.query.type == 'epic' && !$route.query.shareRef">
                    在2024年你一共白嫖了<span class="txt1" :style="colorSty">{{ data.freeGameNumber | numberToCurrency(0)}}</span
                    >款游戏
                </div>
                <div class="txt" v-if="$route.query.type == 'epic' && $route.query.shareRef">
                    在2024年'TA'一共白嫖了<span class="txt1" :style="colorSty">{{ data.freeGameNumber | numberToCurrency(0)}}</span
                    >款游戏
                </div>
                <div class="txt" v-if="$route.query.type == 'steam' || $route.query.type == 'psn'">
                    总共价值达到<span class="txt1" :style="colorSty">{{ data.price }}</span
                    >大洋
                </div>
                <div class="txt" v-if="$route.query.type == 'epic'">
                    总共价值达到<span class="txt1" :style="colorSty">{{ data.freeGameValue | numberToCurrency(0)}}</span
                    >大洋
                </div>
                <div class="txt" v-if="$route.query.type == 'xbox'">
                    总共获得了<span class="txt1" :style="colorSty">{{ data.achievementPoints }}</span
                    >成就点数
                </div>
                <!-- <div class="txt">再坚挺100年就可以用游戏换套房啦！</div> -->
                <div class="txt">{{ data.text }}</div>
                <div class="txt" v-if="$route.query.type != 'xbox' && $route.query.type != 'epic'">
                    <span>悄悄告诉你，其中有</span><span class="txt2" :style="colorSty">{{ data.playLessGame }}</span
                    ><span>款游戏正在吃灰哟~</span><img src="../assets/image/steam/right_big.png" />
                </div>
                <div class="txt" v-if="$route.query.type != 'xbox' && $route.query.type == 'epic' && !$route.query.shareRef">
                    <span>悄悄告诉你，其中有</span><span class="txt2" :style="colorSty">{{ data.playLessGame }}</span
                    ><span>款游戏正在吃灰哟~</span><img src="../assets/image/steam/right_big.png" />
                </div>
                <div class="txt" v-if="$route.query.type != 'xbox' && $route.query.type == 'epic' && $route.query.shareRef">
                    <span>悄悄告诉'TA'，其中有</span><span class="txt2" :style="colorSty">{{ data.playLessGame }}</span
                    ><span>款游戏正在吃灰哟~</span><img src="../assets/image/steam/right_big.png" />
                </div>
            </div>

            <echartPage :main="main" :priceEchartData="priceEchartData"></echartPage>
            <Title :title="data.name"></Title>
            <footerPage class="footerPage"></footerPage>
            <footerBg class="footerBg" :footerBg="footerBg"></footerBg>
        </div>
    </div>
</template>

<script>
import headerPage from "./header.vue";
import echartPage from "./echart.vue";
import Title from "./getTitle.vue";
import footerPage from "./footer.vue";
import footerBg from "./footerBg.vue";
import headerBg from "./headerBg.vue";
import { numberToCurrency } from "../assets/js/numberToCurrency";
export default {
    filters: {
        numberToCurrency
    },
    props: {
        data: {
            type: [Object]
        }
    },
    data() {
        return {
            title: "",
            main: "main2",
            iconSrc: require("../assets/image/" + this.$route.query.type + "/" + this.$route.query.type + "_small.png"),
            headerSty: {
                padding: "4.2rem 0 0 1.95rem"
            },
            footerBg: {
                background: "url(" + require("../assets/image/" + this.$route.query.type + "/xingxing.png") + ")",
                backgroundSize: "42%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom right"
                // backgroundAttachment: 'fixed',
            },
            headerBg: {
                background: "url(" + require("../assets/image/" + this.$route.query.type + "/gamePriceBg.png") + ")",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top right"
                // backgroundAttachment: 'fixed',
            },
            priceEchartData: {},
            colorSty: {}
        };
    },
    mounted() {
        if (this.$route.query.type == "steam") {
            this.colorSty = {
                color: "#5EE6FF"
            };
            this.title = "年度游戏价值";
            this.$set(this.priceEchartData, "xData", this.data.xData);
            this.$set(this.priceEchartData, "yData", this.data.yData);
        } else if (this.$route.query.type == "psn") {
            this.colorSty = {
                color: "#5EA6FF"
            };
            this.title = "年度游戏价值";
            this.$set(this.priceEchartData, "xData", this.data.xData);
            this.$set(this.priceEchartData, "yData", this.data.yData);
        } else if (this.$route.query.type == "xbox") {
            this.colorSty = {
                color: "#5EFF97"
            };
            this.title = "年度成就点数";

            this.$set(this.priceEchartData, "xData", this.data.xData);
            this.$set(this.priceEchartData, "yData", this.data.yData);
        } else if (this.$route.query.type == "epic") {
            this.colorSty = {
                color: "#FF5E5E"
            };
            this.title = "白嫖游戏价值";
            this.$set(this.priceEchartData, "xData", this.data.freeGamePriceX);
            this.$set(this.priceEchartData, "yData", this.data.freeGamePriceY);
        }
    },

    methods: {
        getNumber(val) {
            if (val) {
                return val.toFixed(0);
            }
        }
    },
    components: {
        headerPage,
        echartPage,
        Title,
        footerPage,
        footerBg,
        headerBg
    }
};
</script>

<style>
#gamePrice .txtBox {
    margin: 1.7rem 0 0 1.75rem;
    font-size: 0.73rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.8);
}
#gamePrice .xboxBox{
    margin: 1.7rem 1.75rem 0 1.75rem;
}
#gamePrice .txtBox .txt {
    margin-bottom: 1.45rem;
    line-height: 1.05rem;
}
#gamePrice .txtBox .txt:nth-child(4) {
    margin-bottom: 1rem;
}
#gamePrice .txtBox .txt:last-child {
    margin-bottom: 1.7rem;
}
#gamePrice .txtBox .txt1 {
    font-size: 1.4rem;
    font-family: Impact;
    color: #5ee6ff;
    margin: 0 0.4rem 0 0.65rem;
}
#gamePrice .txtBox .txt2 {
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    color: rgba(94, 230, 255, 0.8);
}
#gamePrice .txtBox .txt:last-child {
    display: flex;
    align-items: end;
}
#gamePrice .txtBox .txt:last-child > span {
    margin-bottom: 0.25rem;
}
#gamePrice .txtBox img {
    width: 1.8rem;
    height: 1.5rem;
    margin-left: 0.7rem;
}
#gamePrice .footerBg{
    height: 11rem;
}
</style>
